// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../css-loader/dist/cjs.js!./jquery-ui.theme.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../vue-style-loader/lib/addStylesClient.js").default
var update = add("4700b2d2", content, true, {});